import { render, staticRenderFns } from "./ImportadorCotizacionesTabla.vue?vue&type=template&id=2ff75d1c"
import script from "./ImportadorCotizacionesTabla.vue?vue&type=script&lang=js"
export * from "./ImportadorCotizacionesTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports